import { animate, style, transition, trigger } from '@angular/animations';

/**
 * fade and in */
export const fadeInAnimation = trigger('fadeInAnimation', [
  transition(':enter', [
    style({ visibility: 'hidden', opacity: 0, zIndex: 1000 }),
    animate('200ms', style({ visibility: 'visible', opacity: 1 })),
  ]),
  transition(':leave', [
    style({ visibility: 'visible', opacity: 1 }),
    animate('200ms', style({ visibility: 'hidden', opacity: 0 })),
  ]),
]);

/**
 * just leave fade*/
export const leaveAnimation = trigger('leaveAnimation', [
  transition(':leave', [
    style({ visibility: 'visible', opacity: 1 }),
    animate('200ms', style({ visibility: 'hidden', opacity: 0 })),
  ]),
]);

/**
 *Drawing*/

export const drawingAnimation = trigger('drawingAnimation', [
  transition(':leave', [
    style({ height: '*', opacity: 1 }),
    animate(200, style({ height: 0, opacity: 0 })),
  ]),
  transition(':enter', [
    style({ height: 0, opacity: 0 }),
    animate(200, style({ height: '*', opacity: 1 })),
  ]),
]);



// WEBPACK FOOTER //
// ./src/environments/animation.ts